import React, { useEffect } from "react";
import { useLenis } from "../components/motion/Reveal";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { BrandMarquee } from "../components/site/BrandMarquee";
import { Manifesto } from "../components/site/Manifesto";
import { StoryVideos } from "../components/site/StoryVideos";
import { Product } from "../components/site/Product";
import { ProductCatalog } from "../components/site/ProductCatalog";
import { ContainerShowcase } from "../components/site/ContainerShowcase";
import { WhyGreen } from "../components/site/WhyGreen";
import { SilentVsDiesel } from "../components/site/SilentVsDiesel";
import { Compare } from "../components/site/Compare";
import { Testimonials } from "../components/site/Testimonials";
import { ROICalculator } from "../components/site/ROICalculator";
import { BlogPreview } from "../components/site/BlogPreview";
import { DistributorSection } from "../components/site/DistributorSection";
import { LeadForm } from "../components/site/LeadForm";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";
import { Footer } from "../components/site/Footer";

export default function Landing() {
  useLenis();
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, []);
  return (
    <div className="grain relative bg-charcoal min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Manifesto />
        <StoryVideos />
        <Product />
        <ProductCatalog />
        <ContainerShowcase />
        <WhyGreen />
        <SilentVsDiesel />
        <Compare />
        <Testimonials />
        <ROICalculator />
        <BlogPreview />
        <DistributorSection />
        <LeadForm />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
